import type { IRelatedModule } from '@platform/core/types';

/** Ключ секції «Пов’язані записи»: модуль + англійський підпис (CRM «Акаунти» й «Контакти» — дві секції одного модуля). Чиста функція. */
export function relatedKeyOf(related: Pick<IRelatedModule, 'module' | 'label'>): string {
  return `${related.module}:${related.label?.en ?? ''}`;
}
